import {
    IAdvisorsResponse,
    IAppointmentsResponse,
    IPostAppointmentRequest,
    IProposalsResponse,
    ITopicsResponse,
    IPutAppointmentRequest,
    IPostAppointmentResponse,
    IPutAppointmentResponse,
    IAppointment
} from "types/advisorServices";
import { IAPITarget, ITypedAPITarget } from "./NetworkStapler";

export function getAppointements(): ITypedAPITarget<IAppointmentsResponse> {
    return {
        url: "/appointments",
        parse: json => json as IAppointmentsResponse
    };
}

export function getTopics(): ITypedAPITarget<ITopicsResponse> {
    return {
        url: "/appointments/topics",
        parse: json => json as ITopicsResponse
    };
}

export function getAdvisors(topicId: string, channelCode: string, branchId?: string): ITypedAPITarget<IAdvisorsResponse> {
    let url = `/appointments/advisors?topicId=${topicId}&channelCode=${channelCode}`;
    if (branchId) {
        url += `&branchId=${branchId}`;
    }

    return {
        url: url,
        parse: json => json as IAdvisorsResponse
    };
}

export function getProposals(
    topicId: string,
    channelCode: string,
    advisorId: string,
    filterFromDate?: Date,
    branchId?: string
): ITypedAPITarget<IProposalsResponse> {
    const query: any = {
        topicId,
        channelCode,
        advisorId
    };

    if (filterFromDate) {
        query.filterFromDate = filterFromDate.toUTCString();
    }

    if (branchId) {
        query.branchId = branchId;
    }

    return {
        url: "/appointments/advisors",
        queryParameters: query,
        parse: json => json as IProposalsResponse
    };
}

export function getRescheduleProposals(
    topicId: string,
    channelCode: string,
    appointmentId: string,
    filterFromDate?: Date,
    // branchId?: string
): ITypedAPITarget<IProposalsResponse> {
    const query: any = {
        topicId,
        channelCode,
        appointmentId
    };

    if (filterFromDate) {
        query.filterFromDate = filterFromDate.toUTCString();
    }

    // Returns 400 -> unknown field
    // if (branchId) {
    //     query.branchId = branchId;
    // }

    return {
        url: "/appointments/advisors",
        queryParameters: query,
        parse: json => json as IProposalsResponse
    };
}

export function getAppointment(appointmentId: string): ITypedAPITarget<IAppointment> {
    return {
        method: "GET",
        url: "/appointments/" + appointmentId,
        parse: json => json as IPostAppointmentResponse
    };
}

export function postAppointment(body: IPostAppointmentRequest): ITypedAPITarget<IPostAppointmentResponse> {
    return {
        method: "POST",
        url: "/appointments",
        body,
        parse: json => json as IPostAppointmentResponse
    };
}

export function deleteAppointment(appointmentId: string): IAPITarget {
    return {
        url: "/appointments/" + appointmentId,
        method: "DELETE"
    };
}

export function putAppointment(appointmentId: string, body: IPutAppointmentRequest): ITypedAPITarget<IPutAppointmentResponse> {
    return {
        url: "/appointments/" + appointmentId,
        method: "PUT",
        body,
        parse: json => json as IPutAppointmentResponse
    };
}



// WEBPACK FOOTER //
// ./src/network/AdvisorServicesAPI.ts